// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabEmailsThreadModalHeader-moduletitle__UoCOD";
export { _1 as "title" }
